import { get } from "lodash-es";

export default (context) => ({
  getModule() {
    return context.$moduleType.getModule();
  },
  dataURItoBlob(dataURI) {
    return context.$file.dataURItoBlob(dataURI);
  },
  // base64 to blob
  base64toBlob(b64Data, contentType) {
    return context.$file.base64toBlob(b64Data, contentType);
  },
  isDeviceOS() {
    return context.$ui.getDeviceOS();
  },
  // getSelectedFilesInfo
  async getSelectedFilesInfo(files, supportedTypes, maxSize, isTotalSize) {
    return context.$file.getSelectedFilesInfo(
      files,
      supportedTypes,
      maxSize,
      isTotalSize,
    );
  },
  // from something application/pdf image/jpeg to .pdf .jpeg
  getExtensionFromType(type) {
    return context.$file.getExtensionFromType(type);
  },
  // from something application/pdf image/jpeg to application, image
  getTypeFromFileType(fileType) {
    return context.$file.getTypeFromFileType(fileType);
  },
  getBytesFromMB(number) {
    return context.$unit.getBytesFromMB(number);
  },
  getBytesFromKB(number) {
    return context.$unit.getBytesFromKB(number);
  },
  getKBFromBytes(number) {
    return context.$unit.getKBFromBytes(number);
  },
  getKBFromMB(number) {
    return context.$unit.getKBFromMB(number);
  },
  getMBFromBytes(number) {
    return context.$unit.getMBFromBytes(number);
  },
  getMBFromKB(number) {
    return context.$unit.getMBFromKB(number);
  },
  // get 1'st', 2'nd', 3'rd', or 4'th'
  // https://stackoverflow.com/a/32696040/9433691
  getOrdinal(number) {
    return context.$unit.getOrdinal(number);
  },
  generatePassword() {
    return context.$common.generatePassword();
  },
  isNumberOnly(value) {
    return context.$formatting.isNumberOnly(value);
  },
  // from '10000' to '10.000'
  decimalFormat(val) {
    return context.$formatting.decimalFormat(val);
  },
  // from '10000' to ' <currency> 10.000'
  convertCurrency(val, currency) {
    return context.$formatting.convertCurrency(val, currency);
  },
  // for generating excel template
  blobExcel(arrData, props, headerRow = 0) {
    return context.$file.blobExcel(arrData, props, headerRow);
  },
  // for generating csv template
  blobCSV(arrData) {
    return context.$file.blobCSV(arrData);
  },
  isProductIncluded(productCategories, menuName) {
    return context.$moduleType.isProductIncluded(productCategories, menuName);
  },
  // check if it's qoala
  isQoala() {
    return context.$role.isQoala();
  },
  // check if it's qoala cs
  isQoalaCS() {
    return context.$role.isQoalaCS();
  },
  // check if it's qoala
  isQoalaAdmin() {
    return context.$role.isQoalaAdmin();
  },
  // check if it's qoala super admin
  isQoalaSuperAdmin() {
    return context.$role.isQoalaSuperAdmin();
  },
  isQoalaAreps() {
    return context.$role.isQoalaAreps();
  },
  isInsurer() {
    return context.$role.isInsurer();
  },
  isPartner() {
    return context.$role.isPartner();
  },
  isServiceCenter() {
    return context.$role.isServiceCenter();
  },
  isPartnerAdmin() {
    return context.$role.isPartnerAdmin();
  },
  isManager() {
    return context.$role.isManager();
  },
  isStoreManager() {
    return context.$role.isStoreManager();
  },
  isSalesAgent() {
    return context.$role.isSalesAgent();
  },
  hasCommission() {
    return context.$permission.hasCommission();
  },
  // checking permission
  hasPermission(permission) {
    return context.$permission.hasPermission(permission);
  },
  colourDashborad(item) {
    return context.$ui.colourDashboard(item);
  },
  // capitalize for one word
  capitalize(word) {
    return context.$formatting.capitalize(word);
  },
  priceFormatToNumber(value) {
    return context.$formatting.priceFormatToNumber(value);
  },
  numberToPriceFormat(value) {
    return context.$formatting.numberToPriceFormat(value);
  },
  currencyFilterRp(val) {
    return context.$formatting.currencyFilterRp(val);
  },
  isPhone(event, value, vModel) {
    return context.$formatting.isPhone(event, value, vModel);
  },
  isNumberOnlyEvent(event, value) {
    return context.$formatting.isNumberOnlyEvent(event, value);
  },
  sumOfArray(arr) {
    return context.$formatting.sumOfArray(arr);
  },
  convertToAMPM(time) {
    return context.$formatting.convertToAMPM(time);
  },
  maxShowText(text, textLength, toggle) {
    return context.$formatting.maxShowText(text, textLength, toggle);
  },
  /* exporting from campaign */
  getCurrencyByCountry(countryId) {
    return context.$formatting.getCurrencyByCountry(countryId);
  },
  getFormattedValue(value, delimiter = ",", commaDelimiter = ".") {
    return context.$formatting.getFormattedValue(
      value,
      delimiter,
      commaDelimiter,
    );
  },
  getUnformattedValue(value, delimiter = ",") {
    return context.$formatting.getUnformattedValue(value, delimiter);
  },
  toFirstLettersUppercase(value, delimiter = "_") {
    return context.$formatting.toFirstLettersUppercase(value, delimiter);
  },
  shortenWords(word, length) {
    return context.$formatting.toFirstLettersUppercase(word, length);
  },
  replaceStrVar(str, data = {}, pattern = /\$\{[A-Za-z0-9_]+\}/g) {
    return context.$formatting.replaceStrVar(str, data, pattern);
  },
  getGridList(oldList, nCol = 4, isVerticalOrder = false) {
    return context.$ui.getGridList(oldList, nCol, isVerticalOrder);
  },
  turnOffCommission() {
    return false;
  },
  /**
   * Utility Helper for <dui-filter> in countOthersFilterFn
   */
  countOthersFilterFn(items) {
    return [];
  },
  /**
   * Utility Helper for <dui-filter> in selectedDynamicFilterFn
   */
  selectedDynamicFilterFn(selectedDynamicFilter) {
    if (context.$moduleType.isPartnership()) {
      const [parentCategory = {}] = selectedDynamicFilter;

      context.store.dispatch(
        "products/partnership/storeProduct",
        parentCategory.field,
      );

      context.store.dispatch("products/partnership/listPartners", {
        query: {
          productCategory: parentCategory.field,
        },
      });
    }
  },
  /**
   * Utility Helper for <dui-form> in submitFormDispatchFn
   */
  submitFormDispatchFn(successMessage) {
    // success notification (string form)
    if (
      typeof successMessage !== "undefined" &&
      successMessage !== null &&
      typeof successMessage === "string"
    ) {
      context.store.dispatch("app/toggleSnackBar", {
        message: successMessage,
        color: "invert-success",
      });
    }

    // success notification (object form)
    if (
      typeof successMessage !== "undefined" &&
      successMessage !== null &&
      typeof successMessage === "object"
    ) {
      context.store.dispatch("app/toggleSnackBar", {
        message: get(successMessage, "message"),
        color: "invert-success",
        doNotClose: get(successMessage, "doNotClose"),
      });
    }
  },
  /**
   * Utility Helper for <dui-form> content.
   */
  formContent() {
    return {
      genAttachFile: context.i18n.t("QoalaDBGeneral.genAttachFile"),
      genMaxFileSize: context.i18n.t("QoalaDBGeneral.genMaxFileSize"),
      genMaxFileResolution: context.i18n.t(
        "QoalaDBGeneral.genMaxFileResolution",
      ),
    };
  },
  /**
   * Utility Helper for <dui-form> in submitFormErrorFn
   */
  submitFormErrorFn(error) {
    context.store.dispatch("app/toggleSnackBar", {
      ...error,
      color: "invert-error",
    });
  },
  /**
   * Utility Helper for <dui-confirm> in handleConfirmSuccess
   * Toggle Snackbar success when press Confirm Popup
   */
  handleConfirmSuccess(successMessage) {
    context.store.dispatch("app/toggleSnackBar", {
      message: successMessage,
      color: "invert-success",
    });
  },
  /**
   * Utility Helper for <dui-confirm> in handleConfirmError
   * Toggle Snackbar error when press Confirm Popup
   */
  handleConfirmError(error) {
    context.store.dispatch("app/toggleSnackBar", {
      message: error.message,
      color: "invert-error",
      isNoSidebarToolbar: true,
    });
  },
  /**
   * Utility Helper for <dui-upload> in addFilesCatchFn
   */
  addFilesCatchFn(err) {
    context.store.dispatch("app/toggleSnackBar", {
      message: err.message,
      color: "invert-error",
    });
  },
  /**
   * Utility Helper for <dui-upload-new> in chooseFileHandlerCatchFn
   */
  chooseFileHandlerCatchFn(error) {
    context.store.dispatch("app/toggleSnackBar", {
      message: error?.message,
      color: "invert-error",
      isNoSidebarToolbar: true,
    });
  },
  /**
   * Utility Helper for <dui-upload-new> inside <ModalCamera> in onSubmitCatchFn
   */
  onSubmitCatchFn(error) {
    context.store.dispatch("app/toggleSnackBar", {
      message: `<b>Error!</b> ${error.message}`,
      color: "invert-error",
    });
  },
  /**
   * Utility Helper for <dui-upload-new> inside <ModalCamera> in startScanCatchFn
   */
  startScanCatchFn(err) {
    context.store.dispatch("app/toggleSnackBar", {
      message: `Error! ${err.message} or Webcam is not supported on your device.`,
      color: "invert-error",
      isNoSidebarToolbar: true,
    });
  },
  /**
   * Utility Helper for <dui-text-editor> in onPickerFileCatchFn
   */
  handlePickerFileCatch(err) {
    context.store.dispatch("app/toggleSnackBar", {
      message: err.message,
      color: "invert-error",
    });
  },
  /**
   * Utility Helper for <dui-date-range>, <dui-date-range-mobile>,
   * <dui-filter>, and <dui-filter-mobile> in applyDateRangeCatchFn
   * or dateRangeApplyDateRangeCatchFn
   */
  applyDateRangeCatchFn(error) {
    context.store.dispatch("app/toggleSnackBar", {
      message: error.message,
      color: "invert-error",
    });
  },

  translateKeyContent(entry, key, defaultValue = "", params = {}) {
    const translatedContent = context.i18n.t(entry)[key];
    const fallbackValue = defaultValue !== "" ? defaultValue : key;
    
    // If there are params, use params version
    if (Object.keys(params).length > 0) {
      return translatedContent
        ? context.i18n.t(`${entry}.${key}`, params)
        : fallbackValue;
    }
    
    // If no params, use original version
    return translatedContent || fallbackValue;
  },

  formatCurlyBracket(str, result) {
    return str.replace(/{(.+?)}/g, (_, g1) => result[g1] || g1);
  },
});
